/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import React from 'react';
import { Button } from 'reactstrap';
import './CopyButton.scss';

export const CopyButton = ({ text }: { text: string }) => {
  return <Button color={'link'} className={'copy-icon'} onClick={() => navigator.clipboard.writeText(text)}>
    < i className='fa fa-copy clickable' />
  </Button>
}
